import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const TeamManagerPage = lazy(() => import('src/pages/manager/team-manager'));
const TeamCreatePage = lazy(() => import('src/pages/manager/team-create'));
const TeamEditPage = lazy(() => import('src/pages/manager/team-edit'));

// ----------------------------------------------------------------------

export const teamRoutes = [
  {
    path: 'teams',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <TeamManagerPage />, index: true },
      {
        path: ':orgId',
        element: <TeamManagerPage />,
      },
      {
        path: ':orgId/create',
        element: <TeamCreatePage />,
      },
      {
        path: 'create',
        element: <TeamCreatePage />,
      },
      {
        path: ':orgId/:teamId/edit',
        element: <TeamEditPage />,
      },
    ],
  },
];
